import * as React from "react";

import "./approval-conflict-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {DeprecatedModalService2}   from "@Common/ui-components/heavy/common/design2/modal-service/modal-service";

export const ApprovalConflictModal = ({cart, next: rootNext}) => cs(
    ["modal", ({}, next) => <DeprecatedModalService2 {...{
        render: ({keepIdOrderApproval, onSelect}, rm) => ({
            onPassiveClose: () => onSelect(false),
            content: next({
                keepIdOrderApproval,
                onSelect: (result) => {
                    onSelect(result);
                },
                close: () => rm(),
            }),
        }),
        next: rootNext,
    }}/>],
    consumeContext("themeScheme"),
    ({modal: {keepIdOrderApproval, onSelect, close}, themeScheme}) => (
        <div className="approval-conflict-modal-2sr">
            <div className="title" style={{color: themeScheme.xpresso.menuBackgroundColor}}>
                Conflicting Order(s) in Your Cart!
            </div>

            <div className="msg-1">
                There is a conflict in your cart. The below orders require approval and must be checked out separately. Please move these orders to pending to continue. 
                Orders Requiring Approval:
            </div>
            {cart?.items.map((item) => cs(
                keyed(item.itemId),
                ({}) => (    
                    item.approvalInfo?.idOrderApproval != keepIdOrderApproval && 
                    (   
                        <div 
                            xd-qa-type="label" 
                            xd-qa-name={"Item Name " + item.itemId}
                            className="msg-2"
                            title={item.itemName || item.metaData?.productName || "Brochure"}
                        >
                            {item.itemName || item.metaData?.productName || "Brochure"}
                        </div>
                    )
                ),
            ))}

            <div className="buttons">
                <button
                    xd-qa-type="button"
                    onClick={async () => {
                        onSelect(true);
                        close();
                    }}
                >
                    MOVE ALL APPROVAL ORDERS TO PENDING
                </button>
            </div>

            <div className="msg-3">
                <a
                    xd-qa-type="link"
                    onClick={async () => {
                        onSelect(false);
                        close();
                    }}
                >
                    RETURN TO CART
                </a>
                {" "}
                to manually move approval orders to Pending
            </div>

        </div>
    ),
);